import {updateFactory, Reducer} from '@modifi/redux'
import {getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'
import {PersonLegalRole} from '@modifi/enums'
import {aPush} from '@modifi/router'
import {aCloseDialog} from '@modifi/plugin-dialogs'

import {
  aDeleteLocalLegalRepresentative,
  aFetchLegalRepresentatives,
} from '../../data/legal-representatives'
import {aFetchInputFields} from '../../data/input-fields'
import {ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES} from '../../routes/constants'

const apiClient = getAuthenticatedThemisClient()

const {actions, selectors, reducer} = updateFactory({
  rootSelector: state => state?.features?.deleteLegalRep,
  actionNamePrefix: 'features/legal-rep/delete',
  submitRequest:
    (a, externalPersonId: string) =>
    // eslint-disable-next-line consistent-return
    async (dispatch): Promise<any> => {
      dispatch(a.pendingAction())
      try {
        await apiClient.Person.delete({
          externalPersonId,
          legalRole: PersonLegalRole.LEGAL_REPRESENTATIVE,
        })
      } catch (error: any) {
        dispatch(a.errorAction(error))
        return null
      }
      dispatch(a.successAction())
      dispatch(aCloseDialog())
      dispatch(aDeleteLocalLegalRepresentative(externalPersonId))

      await Promise.all([dispatch(aFetchInputFields()), dispatch(aFetchLegalRepresentatives())])
      await dispatch(aPush(ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES))
    },
})

export default reducer as Reducer

export const {aSubmit: aDelete, aReset: aReset} = actions

export const {
  selectUpdatePending: selectDeleteIsPending,
  selectUpdateErrorMessage: selectDeleteErrorMessage,
} = selectors
